<template>
	<header id="uw-header" class="header">
		<section class="purple">
			<div class="container">
				<a href="http://uw.edu" title="University of Washington Home" class="uw-patch">
				<!-- <img src="../assets/svg/uw-sprite.svg"></img> -->
				</a>
				<a href="https://www.washington.edu/" title="University of Washington" class="uw-wordmark" tabindex="-1" aria-hidden="true">
				</a>
			</div>
		</section>
		<section class="white">
			<div class="container">
				<h1>{{title}}</h1>
			</div>
		</section>
	</header>
</template>

<script>
	// import Navigation from './Navigation.vue'
	
	export default {
		name: 'UWHeader',
		components: {
		},
		data: function() {
			return {
				title: "Net Price Calculator",
				loading:false,
				images: {
					// logo: require('./assets/svg/uw-sprite.svg')
				}
			}
		},
		props: {
		},
		created: function() {
			// this.strings = asp_strings;
		},
		mounted: function () {
			
		}
	}
</script>

<style scoped>


/* @media only screen and (max-width:767px) {
	.uw-patch {
		width: 73px;
		height: 45px;
		top: 0;
		left: 0;
		background-size: 470px;
	}
} */

.header {
	/* height:100px; */
	text-align: center;
}

.header .purple{
	background-color:#4b2e83;
	height:90px;
	box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);
	position: relative;
}

.header .white{
	background-color:white;
	/* height:60px; */
	padding-top: 2rem;
	padding-bottom: 1rem;
}

.uw-site-title {
	text-align: center;
	margin: 70px 0px 30px 0px;
}

.uw-patch {
	background: url(../assets/svg/uw-sprite.svg) no-repeat 0 0 transparent;
	display: block;
	text-indent: -9999px;
	width: 163px;
	height: 90px;
	z-index: 1;
	top: 0;
	left: 0;
}
.uw-patch:hover {
	background: url(../assets/svg/uw-sprite-focus.svg) no-repeat 0 0 transparent;
}

.uw-wordmark {
	display: block;
	height:50px;
	position: absolute;
	/* text-indent: -9999px; */
	background: url(../assets/svg/uw-sprite.svg) no-repeat transparent 0 -431px;
	background-color: transparent;
	background-color: transparent;
	top: 38%;
	left: 10rem;
	width: 330px;
}

/* Small Devices, Tablets */
@media only screen and (max-width: 767px) {
	.header .purple{
		height:49px;
	}

	.uw-patch {
		width: 73px;
		height: 50px;
		background-size: 470px;
	}

	.uw-wordmark {
		height:38px;
		top: 7px;
		left:105px;
		width: 230px;
	}
}

</style>